import React from 'react';
import PropTypes from 'prop-types';

class ListItemIcon extends React.PureComponent {
  render() {
    let { className, component: Component, variant, ...other } = this.props;

    Component = variant === 'image' ? Component : 'span';

    return <Component className={className} {...other} />;
  }
}

ListItemIcon.propTypes = {
  className: PropTypes.string,
  component: PropTypes.string,
  variant: PropTypes.oneOf(['image', 'icon']),
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const ListItemIcon = ({prop = val, component = 'img', className = '', variant = 'image' }) =>

export default ListItemIcon;
